import { CustomerInfo, UserInfo, CallStatus } from './common';

export const CallStatusDefault: CallStatus = {
  isFetching: false,
  errorMsg: '',
};

export const CustomerInfoDefault: CustomerInfo = {
  customerId: '',
  customerName: '',
};

export const UserInfoDefault: UserInfo = {
  userId: '',
  email: '',
  customer: { ...CustomerInfoDefault },
};
